import ReactGA from 'react-ga';
import {gaId} from './http';

export const gaInit = (theme, shopId) => {
    ReactGA.initialize(gaId);    
    let currentTime = new Date().getTime();
    localStorage.setItem('loadedTime', currentTime);
    ReactGA.pageview(theme, shopId);    
}

export const gaEvent = (category, action, label) => {
    ReactGA.event({
        category,
        action,
        label
    });
}

export const gaTiming = (category, variable, label, startTime = '') => {
    let loadedTime = startTime === '' ? localStorage.getItem('loadedTime') : startTime,
        bookedTime = new Date().getTime(),
        value = parseInt(bookedTime) - parseInt(loadedTime);
    ReactGA.timing({
        category,
        variable,
        value, // in milliseconds
        label
    });
}